import makeStyles from "@material-ui/core/styles/makeStyles";

const style = theme => ({
});

export default makeStyles(style);